export const loginValidation = (uname,id)=>{

    if(uname && id){
        return true;
    }
    else{
        return false
        }
}